import { usei18n } from '../i18n/i18n.js';
import { useLanguage } from '../context/LanguageContext.js';
import Modal from './Modal.js';
import './TooSoonWarningModal.css';

const TooSoonWarningModal = ({timeSince, onProceed, onClose}) => {
    const {language} = useLanguage();
    const [, minutes] = timeSince;
    const i18n = usei18n(language);
    const formattedMinutes = language === 'he-IL' ? `${minutes} דק` : `${minutes} min`;
    return (
        <Modal onClose={onClose} onBackdropClick={onClose} id="too-soon-warning">
            <p className="warning-message">
                {i18n('modal.warning.itsOnlyBeen')} <span className="time-since">{formattedMinutes}</span> {i18n('sinceLastDose')}
            </p>
            <button className="warning-button save" onClick={onProceed}>{i18n('modal.warning.addAnyway')}</button>
        </Modal>
    );
}

export default TooSoonWarningModal;
